import API from "@/api";

const SET_PRELOADER = "SET_PRELOADER";
const SET_CONFIGURABLE_FIELD = "SET_CONFIGURABLE_FIELD";
const SET_CONFIGURABLE_FIELD_OPTIONS = "SET_CONFIGURABLE_FIELD_OPTIONS";
const SET_ORDER_ID = "SET_ORDER_ID";
const SET_ANSWER = "SET_ANSWER";
const RESET_STATE = "RESET_STATE";

export default {
  namespaced: true,

  state: {
    orderId: "",
    answer: null,
    configurableField: {
      key: "CUSTOMER_ALLOW_PROFESSIONAL_CHANGE_IN_NO_SHOW_CASE"
    },
    configurableFieldOptions: [],
    preloader: false
  },

  actions: {
    async getConfigurableField({ state, commit }) {
      commit("SET_PRELOADER", true);

      try {
        const configField = await API.ConfigurableFields.getConfigurableFieldByKey(
          state.configurableField.key
        );
        commit("SET_CONFIGURABLE_FIELD", configField);
      } catch (e) {
        throw e;
      }

      commit("SET_PRELOADER", false);
    },

    async getConfigurableFieldOptions({ state, commit }) {
      commit("SET_PRELOADER", true);

      try {
        const options = await API.ConfigurableFieldOption.getOptionsByConfigurableField(
          state.configurableField.id
        );

        commit("SET_CONFIGURABLE_FIELD_OPTIONS", options.data);
      } catch (e) {
        throw e;
      }

      commit("SET_PRELOADER", false);
    },

    async setPreference({ state }, orderId) {
      try {
        const response = await API.OrderHasPreferences.create(
          orderId,
          state.configurableField.id,
          state.answer
        );

        return response;
      } catch (_) {
        // Suppress the error and do nothing when an exception occur here.
      }
    },

    setOrderId({ commit }, orderId) {
      commit("SET_ORDER_ID", orderId);
    },

    setAnswer({ commit }, optId) {
      commit("SET_ANSWER", optId);
    },

    resetState({ commit }) {
      commit("RESET_STATE");
    }
  },

  mutations: {
    [SET_CONFIGURABLE_FIELD](state, payload) {
      state.configurableField = payload;
    },
    [SET_PRELOADER](state, payload) {
      state.preloader = payload;
    },
    [SET_CONFIGURABLE_FIELD_OPTIONS](state, payload) {
      state.configurableFieldOptions = payload;
    },
    [SET_ORDER_ID](state, payload) {
      state.orderId = payload;
    },
    [SET_ANSWER](state, payload) {
      state.answer = payload;
    },
    [RESET_STATE](state) {
      state.orderId = "";
      state.answer = null;
      state.configurableField = {
        key: "CUSTOMER_ALLOW_PROFESSIONAL_CHANGE_IN_NO_SHOW_CASE"
      };
      state.configurableFieldOptions = [];
      state.preloader = false;
    }
  },

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/orders/preferences/customer/allow_professional_change.js